import axios from "axios";
import constants from "../constants";

const skills = (allSkills) => {
  return {
    type: constants.adminActions.fetchAllSkills,
    allSkills,
  };
};

export const getAllSkills = () => async (dispatch) => {
  try {
    const url = "/admin/skill";
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseBody, responseStatus);
    dispatch(skills(responseBody.data));
    console.log(responseBody.data.filter((skill) => !skill.parentId));
  } catch (error) {
    console.log(error);
  }
};

export const deleteSkill = (skillId) => async (dispatch) => {
  try {
    const url = `/admin/skill?id=${skillId}`;
    const { responseStatus } = await axios.delete(url);
    if (responseStatus === constants.status.success) {
      await dispatch(getAllSkills());
    }
  } catch (error) {
    console.log(error);
  }
};

export const addSkill = (skillDetails) => async (dispatch) => {
  try {
    const url = "/admin/skill";
    const { responseStatus } = await axios.post(url, skillDetails);
    if (responseStatus === constants.status.success) {
      await dispatch(getAllSkills());
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateSkill = (details) => async (dispatch) => {
  try {
    const url = "/admin/skill";
    const { responseStatus } = await axios.put(url, details);
    if (responseStatus === constants.status.success) {
      await dispatch(getAllSkills());
    }
  } catch (error) {
    console.log(error);
  }
};
